var _excluded = ["disabled", "error", "errorMessage", "fieldSize", "fieldWidth", "id", "label", "labelledBy", "message", "name", "placeholder", "readOnly", "required", "resize", "tabIndex", "value"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import FieldError from "../FieldError/FieldError.js";
import FieldLabel from "../FieldLabel/FieldLabel.js";
import FieldMessage from "../FieldMessage/FieldMessage.js";
var StyledTextarea = styled.textarea.withConfig({
  componentId: "CL__sc-1vket0k-0"
})(["appearance:none;display:block;background:var(--main-bkg-color);color:var(--field-text-color);position:relative;box-shadow:none;outline:none;width:", ";max-width:100%;border:1px solid var(--field-border-color);border-radius:var(--border-radius-x-small);transition:border-color var(--hover-transition);resize:", ";", " ", " ", " &:not(:disabled):hover{box-shadow:none;border-color:var(--highlight-color);}&:not(:disabled):focus-visible{box-shadow:0 0 5px var(--highlight-color);border-color:var(--highlight-color);}::placeholder{color:var(--gray-5);opacity:1;font:inherit;}&::selection{background:var(--highlight-color);color:var(--main-bkg-color);}&::-moz-focus-inner{margin-top:-2px;margin-bottom:-2px;border:0;padding:0;}&:-webkit-autofill,&:-webkit-autofill:hover,&:-webkit-autofill:focus-visible{-webkit-text-fill-color:var(--main-bkg-color);box-shadow:0 0 0 1000px var(--main-bkg-color) inset;}", " ", " ", " ", ""], _ref => {
  var {
    fieldWidth
  } = _ref;
  return fieldWidth === 'full' ? '100%' : "".concat(fieldWidth, "px");
}, _ref2 => {
  var {
    resize
  } = _ref2;
  return resize;
}, _ref3 => {
  var {
    fieldSize
  } = _ref3;
  return fieldSize === 'large' ? "\n    min-height: calc(var(--spacing-4) + 3rem);\n    padding: var(--spacing-2) var(--spacing-3);\n    font: var(--body-text-medium);\n  " : "";
}, _ref4 => {
  var {
    fieldSize
  } = _ref4;
  return fieldSize === 'medium' ? "\n  min-height: calc(var(--spacing-2) + 3rem);\n    padding: var(--spacing-1) 15px;\n  font: var(--body-text-small);\n" : "";
}, _ref5 => {
  var {
    fieldSize
  } = _ref5;
  return fieldSize === 'small' ? "\n  min-height: calc(var(--spacing-1) + 2.25rem);\n  padding: 3px 9px;\n  font: var(--body-text-x-small);\n" : "";
}, _ref6 => {
  var {
    error
  } = _ref6;
  return error && "\n    border-color: var(--error-color);\n\n    &:not(:disabled):hover {\n      border-color: var(--error-color);\n    }\n\n    &:not(:disabled):focus-visible {\n      box-shadow: 0 0 5px var(--error-color);\n      border-color: var(--error-color);\n    }\n  ";
}, _ref7 => {
  var {
    disabled
  } = _ref7;
  return disabled && "\n    background-color: var(--surface-bkg-color);\n    border-color: var(--border-color-dim);\n  ";
}, _ref8 => {
  var {
    error,
    readOnly
  } = _ref8;
  return readOnly && !error && css(["border-color:var(--gray-2);[data-theme='dark'] &{border-color:var(--gray-8);}"]);
}, _ref9 => {
  var {
    readOnly
  } = _ref9;
  return readOnly && css(["color:var(--text-color-dim);"]);
});
var Textarea = /*#__PURE__*/forwardRef((_ref10, ref) => {
  var {
      disabled = false,
      error = false,
      errorMessage = "There's an error with this field",
      fieldSize = 'medium',
      fieldWidth = 'full',
      id = '',
      label,
      labelledBy,
      message,
      name = '',
      placeholder = '',
      readOnly = false,
      required = false,
      resize = 'vertical',
      tabIndex = 0,
      value
    } = _ref10,
    props = _objectWithoutProperties(_ref10, _excluded);
  return /*#__PURE__*/React.createElement("div", null, label && /*#__PURE__*/React.createElement(FieldLabel, {
    fieldSize: fieldSize,
    htmlFor: id,
    required: required
  }, label), /*#__PURE__*/React.createElement(StyledTextarea, _extends({
    "aria-label": label,
    "aria-labelledby": labelledBy,
    disabled: disabled,
    error: error,
    fieldSize: fieldSize,
    fieldWidth: fieldWidth,
    id: id,
    name: name,
    placeholder: placeholder,
    readOnly: readOnly,
    ref: ref,
    resize: resize,
    required: required,
    tabIndex: tabIndex,
    value: value
  }, props)), message && !error && /*#__PURE__*/React.createElement(FieldMessage, {
    fieldSize: fieldSize,
    htmlFor: id
  }, message), errorMessage && error && /*#__PURE__*/React.createElement(FieldError, {
    fieldSize: fieldSize,
    htmlFor: id
  }, errorMessage));
});
export default Textarea;